/**
 * Texto de un código que manda la API, con el **código crudo** como respaldo.
 *
 * Los avisos y los motivos de descarte del módulo de RRHH no son enumerados de Java: son cadenas
 * sueltas que cada servicio añade a una lista. Cuando la API estrena uno y aquí no se añade su
 * traducción, `$t` devuelve la clave entera y la pantalla escribe literalmente
 * «explicacionia.avisos.TRAMO_DE_LA_SOLICITUD» debajo de la explicación —pasó con ese aviso y con
 * `EXPLICACION_SIN_RASTRO` (revisión CODEX del PR #1711)—. El código a secas no es bonito, pero se
 * entiende y, sobre todo, deja ver que hay un aviso.
 *
 *   textoCodigo(this, 'reglascoincidencia.avisos', aviso)
 *
 * No vale para los enumerados (estado, tipo, severidad, origen, acción del rastro): esos sí están
 * cerrados en Java y su tabla se revisa al añadir un valor.
 */
export default function textoCodigo(vm, espacio, codigo) {
  if (!codigo) return '';
  const clave = espacio + '.' + codigo;
  return vm.$te(clave) ? vm.$t(clave) : codigo;
}
